import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import { trackDownload } from '../../../../service/matomo';

const NUMBER_OF_PAGES = 9;
export const MAX_ELEMENTS_PER_LIST = 50;

const elementConversion = (pageNo: number) => {
    const header = document.getElementById('export-header');
    if (!header) throw new Error('Failed to fetch element to print');
    const headerCanvas = html2canvas(header);
    const contentArr = [];
    for (let i = 0; i < pageNo; i++) {
        const content = document.getElementById(`export-page-content-${i+1}`);
        if (!content) throw new Error(`Failed to fetch element with id: export-page-content-${i+1}`);
        contentArr.push(html2canvas(content));
    }
    return [headerCanvas, ...contentArr];
};

export const dateFormatDaily = (dateStr: string) => {
    const isDayFormat = (dateStr.match(/-/g) || []).length === 2;
    if (isDayFormat) {
      const dateArr = dateStr.split('-');
            return dateArr[2] + '-' + dateArr[1] + '-' + dateArr[0];
    }
    return dateStr;
};

export const exportDownload = async (additionalPages: number) => {
    const pageNo = NUMBER_OF_PAGES + additionalPages;
    try {
        const canvasArrPromise = elementConversion(pageNo);
        const canvasArr = await Promise.all(canvasArrPromise);

        console.log('canvasArr:', canvasArr);

        // Extracting image data from canvases
        const [headerCanvas, ...contentCanvasArr] = canvasArr;
        const headerImgData = headerCanvas.toDataURL('image/png');
        const contentImgDataArr = contentCanvasArr.map(contentCanvas => contentCanvas.toDataURL('image/png'));

        const pdf = new jsPDF({ orientation: 'landscape' });

        // Footer generation
        const date = new Date();
        const formatterDate = new Intl.DateTimeFormat('en-US', {
            day: '2-digit', month: '2-digit', year: 'numeric'
        });
        const formattedDate = formatterDate.format(date);
        const formatterTime = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
        const formattedTime = formatterTime.format(date);
        pdf.setFontSize(12);
        const timeTextDim =
        pdf.getTextDimensions('Created at: ' + formattedDate + ' ' + formattedTime);

        // Get sizes for document building
        const headerImgProps = pdf.getImageProperties(headerImgData);
        const pdfPageWidth = pdf.internal.pageSize.getWidth();
        const pdfPageHeight = pdf.internal.pageSize.getHeight();
        const headerHeightPerPage = (headerImgProps.height * pdfPageWidth) / headerImgProps.width;

        const contentImgProps = pdf.getImageProperties(contentImgDataArr[0]); // Assuming all content images have same dimensions
        const contentHeightPerPage = pdfPageHeight - headerHeightPerPage - timeTextDim.h;
        const maxCanvasHeightPerPage = (contentImgProps.width * contentHeightPerPage) / pdfPageWidth;

        // Pages generation
        contentCanvasArr.forEach((contentCanvas, i) => {
            if (i > 0) pdf.addPage();

            // Content print
            const canvas = document.createElement('canvas');
            canvas.width = contentImgProps.width;
            canvas.height = maxCanvasHeightPerPage;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                console.error('An error occurred while drawing the PDF content');
                return;
            }
            ctx.drawImage(contentCanvas, 0, 0, contentImgProps.width, contentImgProps.height);
            const pageImgData = canvas.toDataURL('image/png');

            // Header print
            pdf.addImage(
                headerImgData, 'JPEG',
                0, 0,
                pdfPageWidth, headerHeightPerPage,
                undefined, 'FAST'
            );
            pdf.addImage(
                pageImgData, 'JPEG',
                5, (headerHeightPerPage + 2.5),
                pdfPageWidth - 10, contentHeightPerPage - 5,
                undefined, 'FAST'
            );

            // Footer print
            pdf.setFontSize(8);
            pdf.text(
                'Report Name: BRAD Homepage Report',
                4, pdfPageHeight - timeTextDim.h
            );
            pdf.text(
                'Created at: ' + formattedDate + ' ' + formattedTime,
                (pdfPageWidth / 2) - (timeTextDim.w / 2), pdfPageHeight - timeTextDim.h
            );
            const pageTextWidth = pdf.getTextWidth('Page: ' + (i + 1) + '/' + pageNo);
            pdf.text(
                'Page: ' + (i + 1) + '/' + pageNo,
                pdfPageWidth - pageTextWidth - 4, pdfPageHeight - timeTextDim.h
            );
        });

        pdf.save('brad_homepage_report.pdf');
        trackDownload('brad_homepage_report.pdf', 'pdf-export');
    } catch (err) {
        console.error(err);
    }
};